"use client";

type FAQItem = {
  question: string
  answer: string
}


const FaqItem = ({ faq }: { faq: FAQItem }) => (
  <div className="bg-gray-100 mb-[1px]">
    <h5 className="p-4 lg:p-6 mb-0 w-full text-start flex justify-between items-center text-xl font-medium">
      <span>{faq.question}</span>
    </h5>
    <div className="px-3 lg:px-6 pb-2 lg:pb-6">
      <p className="opacity-50">{faq.answer}</p>
    </div>
  </div>
);


const FAQs = () => {
  const items: FAQItem[] = [
    {
      "question":
        `在线提取伴奏服务是否免费？`,
      "answer":
        `音子AI承诺提供永久的免费在线提取伴奏次数，您只需每日登录一次网站，会自动赠送3音子，每月大约可使用5次在线提取伴奏，如您有更多的在线提取伴奏次数需求，可以付费购买。`
    }
    ,
    {
      "question": `在线提取伴奏和分离人声功能需要付费吗？`,
      "answer":
        `当前只对在线提取伴奏、分离人声、提取视频音乐、文本转语音这4个功能进行付费服务，具体计费规则可查看价格页面。网站每月会赠送一定量音子数量，可以用于抵扣这些付费功能。`
    }
    ,
    {
      "question":
        `在线提取伴奏和分离人声支持哪些音视频格式？`,
      "answer":
        `人声分离过程通常需要几分钟，具体时间取决于上传文件的大小和当前服务器的处理负载。我们努力确保所有用户都能尽快收到结果。`
    }
    ,
    {
      "question":
        `人声分离的音轨质量如何？`,
      "answer":
        `我们使用先进的AI技术确保音轨人声分离的高质量。在大多数情况下，分离的人声和伴奏都将保持清晰和原始的音质。`
    }
    ,
    {
      "question":
        `我可以删除我上传的文件吗？`,
      "answer":
        `为了方便其他客户能直接下载已经分离的音频，我们默认会保存并公开分享分离后的音频文件，但是您可以在完成分离后选择立即删除您的文件，我们承诺您选择删除时，会立刻从服务器上永久删除。`
    }
    ,
    {
      "question":
        `如果我对人声分离结果不满意，我该怎么办？`,
      "answer":
        `如果您对人声分离结果不满意，我们建议您重新上传文件并尝试不同的设置，或者联系我们的客服团队寻求帮助。我们致力于确保每位用户都能获得最佳的服务体验。`
    }
  ];


  return (
    <section className="mx-auto py-14 md:py-24 bg-gray text-zinc-900">
      <div className="container md:px-4 mx-auto">
        <div className="grid grid-cols-12 max-w-7xl mx-auto text-center md:text-left">
          <div className="col-span-12 lg:col-span-8 mb-2">
            <h2 className="font-bold text-3xl  md:text-[45px] leading-none mb-6">
              {`常见问题`}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 justify-between max-w-7xl mx-auto">
          <div className="hidden md:block  col-span-12 md:col-span-4 mb-6 md:mb-0">
            <div
              className="bg-center bg-no-repeat bg-cover min-h-[150px] w-full rounded-2xl h-full"
              style={{
                backgroundImage:
                  "url(https://public-image.fafafa.ai/fa-image/2024/07/b8bf7e02d2ea0b6925feece8e004f954.webp)"
              }}
            ></div>
          </div>
          <div className="col-span-12 md:col-span-8 lg:pl-12">
            {items.map((faq, i) => (
              <FaqItem faq={faq} key={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;